import React from "react";
import cn from "classnames";
import styles from "./Panel.module.sass";
import Icon from "../../../../components/Icon";
import { downloadContract } from "../../../../services/contract.service";
import { showSuccess, showError } from "../../../../services/toast.service";

const Panel = ({ selectedContracts = [], onClearSelection }) => {
  // Ne pas afficher le panel s'il n'y a pas de contrats sélectionnés
  if (!selectedContracts.length) return null;
  // Fonction pour télécharger les contrats sélectionnés
  const handleDownloadContracts = async () => {
    if (!selectedContracts.length) return;
    
    try {
      let downloadCount = 0;
      
      // Télécharger chaque contrat sélectionné
      for (const contract of selectedContracts) {
        if (contract.document) {
          await downloadContract({...contract, fileField: 'document'});
          downloadCount++;
        }
      }
      
      if (downloadCount > 0) {
        showSuccess(`${downloadCount} contrat(s) téléchargé(s) avec succès`);
      } else {
        showError('Aucun contrat disponible au téléchargement');
      }
    } catch (error) {
      showError('Erreur lors du téléchargement des contrats');
      console.error(error);
    }
  };

  // Fonction pour télécharger les conventions sélectionnées
  const handleDownloadConventions = async () => {
    if (!selectedContracts.length) return;
    
    try {
      let downloadCount = 0;
      
      // Télécharger chaque convention sélectionnée
      for (const contract of selectedContracts) {
        if (contract.convention) {
          await downloadContract({...contract, fileField: 'convention'});
          downloadCount++;
        }
      }
      
      if (downloadCount > 0) {
        showSuccess(`${downloadCount} convention(s) téléchargée(s) avec succès`);
      } else {
        showError('Aucune convention disponible au téléchargement');
      }
    } catch (error) {
      showError('Erreur lors du téléchargement des conventions');
      console.error(error);
    }
  };

  return (
    <div className={cn("panel", styles.panel)}>
      <div className={styles.info}>
        <Icon name="check-all" size="24" />
        <span>{selectedContracts.length} contrat{selectedContracts.length > 1 ? 's' : ''} sélectionné{selectedContracts.length > 1 ? 's' : ''}</span>
      </div>
      <div className={styles.btns}>
        <button className={cn("button-stroke", styles.button)} onClick={handleDownloadContracts}>
          <Icon name="download" size="24" />
          <span>Télécharger contrats</span>
        </button>
        <button className={cn("button-stroke", styles.button)} onClick={handleDownloadConventions}>
          <Icon name="download" size="24" />
          <span>Télécharger conventions</span>
        </button>
        <button className={cn("button-stroke", styles.button)} onClick={onClearSelection}>
          <Icon name="close" size="24" />
          <span>Annuler</span>
        </button>
      </div>
    </div>
  );
};

export default Panel;
